export const getPaymentRedactionAttributes = () => ({
  "data-private": "lipsum",
  "data-ph-no-capture": true,
  "data-sentry-mask": true,
  "data-sensitive": "payment",
  autoComplete: "off",
  "data-lpignore": "true",
  "data-form-type": "payment",
});

export const getPaymentContainerRedactionAttributes = () => ({
  "data-private": "lipsum",
  "data-ph-no-capture": true,
  "data-sentry-mask": true,
  "data-sensitive": "payment",
});
